export default (state) => ({
  userErrorMessages: state.ViewProfileDialog.userErrorMessages,
  showToast: state.ViewProfileDialog.showToast,
  errorToastMessage: state.ViewProfileDialog.errorToastMessage,
  errorCode: state.ViewProfileDialog.errorCode,
  severity: state.ViewProfileDialog.severity,
  countryList: state.ViewProfileDialog.countryList,
});
